import React, { memo } from 'react'
import { useQuotationCard, QuotationCardProps } from './useQuotationCard'
import blockContentToHtml from '@sanity/block-content-to-html'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styles from './QuotationCard.module.scss'

const QuotationCard: React.FC<QuotationCardProps> = (
  props: QuotationCardProps
) => {
  const { title, description } = useQuotationCard(props)

  return (
    <div className={`${styles['quotation-card']} d-flex`}>
      <div>
        <FontAwesomeIcon
          icon={['fas', 'quote-left']}
          className={`${styles.icon} ${styles.top}`}
        />
        <h5>{title}</h5>
        <div
          className={styles.description}
          dangerouslySetInnerHTML={{
            __html: Array.isArray(description)
              ? blockContentToHtml({
                  blocks: description,
                })
              : `<p>${description}</p>`,
          }}
        ></div>
        <FontAwesomeIcon
          icon={['fas', 'quote-right']}
          className={`${styles.icon} ${styles.bottom}`}
        />
      </div>
    </div>
  )
}

export default memo(QuotationCard)
